import React from 'react';
import styled from 'styled-components';
import { Color } from '../../GlobalStyles/theme';

export enum Direction {
    Right = 'right',
    Left = 'left',
    Up = 'up',
    Down = 'down',
}

export const RotationDegrees = {
    [Direction.Right]: 'rotate(225deg)',
    [Direction.Left]: 'rotate(45deg)',
    [Direction.Up]: 'rotate(135deg)',
    [Direction.Down]: 'rotate(315deg)',
};

export const StyledArrowIcon = styled.span<{ direction?: Direction; size?: number }>`
    height: ${({ size = 7 }) => size}px;
    width: ${({ size = 7 }) => size}px;
    border-left: 1px solid ${({ theme }) => theme.colors.charcoal100};
    border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal100};
    display: inline-block;
    transform: ${({ direction = Direction.Left, size = 0 }) =>
        `${direction === Direction.Up ? `translateY(${size / 2 || 3.5}px)` : ''} ${RotationDegrees[direction]}`};
`;

export const StyledCrossIcon = styled.div<{ color?: Color; strokeWidth?: number }>`
    position: absolute;
    width: 100%;
    height: 100%;

    :before,
    :after {
        position: absolute;
        left: 50%;
        content: ' ';
        height: 100%;
        width: ${({ strokeWidth = 10 }) => `${strokeWidth}%`};
        background-color: ${({ theme, color }) => (color ? theme.colors[color] : theme.colors.charcoal100)};
    }
    :before {
        transform: rotate(45deg);
    }
    :after {
        transform: rotate(-45deg);
    }
`;

const StyleIconContainer = styled.div<{ width: string; height: string }>`
    position: relative;
    width: ${({ width }) => width};
    height: ${({ height }) => height};
`;
interface CrossIconProps extends React.HTMLProps<HTMLDivElement> {
    width?: number;
    height?: number;
    color?: Color;
    className?: string;
    strokeWidth?: number;
}

const StyledSearchIcon = styled.div`
    position: absolute;
    padding: 0;
    border: none;
    background: none;

    &:before,
    &:after {
        display: block;
        position: relative;
        content: '';
        width: 9px;
        height: 9px;
    }

    &:before {
        border-radius: 50%;
        border: 1px solid ${({ theme }) => theme.colors.charcoal60};
    }

    &:after {
        left: 4px;
        transform: rotateZ(45deg);
        border-top: 1px solid ${({ theme }) => theme.colors.charcoal60};
    }
`;

export const CrossIcon: React.FC<CrossIconProps> = ({ width = 11, height = 11, className, color, strokeWidth }) => (
    <StyleIconContainer className={className} width={`${width}px`} height={`${height}px`}>
        <StyledCrossIcon color={color} strokeWidth={strokeWidth} />
    </StyleIconContainer>
);

export const SearchIcon: React.SFC = () => (
    <StyleIconContainer width="14px" height="14px">
        <StyledSearchIcon />
    </StyleIconContainer>
);

export const StyledDismissIcon = styled.button`
    position: absolute;
    display: block;
    padding: 0;
    border: none;
    background: none;

    &:before,
    &:after {
        display: block;
        position: relative;
        content: '';
        width: 21px;
        height: 21px;
        border-top: 1px solid ${({ theme }) => theme.colors.charcoal100};
    }

    &:before {
        transform: rotateZ(45deg);
        top: 5px;
        left: -3px;
    }

    &:after {
        transform: rotateZ(-45deg);
        top: -16px;
        left: 11px;
    }
`;

export const StyledPlusIcon = styled.div`
    padding: 0;
    border: none;
    background: none;
    &:before,
    &:after {
        display: block;
        position: relative;
        content: '';
        width: 9px;
        height: 9px;
    }

    &:before {
        top: 5px;
        left: 4px;
        border-left: 1px solid ${({ theme }) => theme.colors.charcoal60};
    }

    &:after {
        right: 0;
        border-top: 1px solid ${({ theme }) => theme.colors.charcoal60};
    }
`;

export const StyledMinusIcon = styled.button`
    display: block;
    padding: 0;
    border: none;
    background: none;
    &:before,
    &:after {
        display: block;
        position: relative;
        content: '';
        width: 9px;
        height: 9px;
    }
    &:after {
        right: 0;
        border-top: 1px solid ${({ theme }) => theme.colors.charcoal60};
    }
`;
